export default __webpack_public_path__ + "static/media/mao-com-dinheiro.7e349c5d.png";